module.exports = __webpack_public_path__ + "static/media/1pic@2x.632dc68e.png";